import React from 'react';

import Button from 'components/Button/Button';

import styles from './PaymentStatus.module.scss';

const PaymentStatus = ({ paymentStatus }) => {
    if (!paymentStatus) return null;

    const { status, data, error } = paymentStatus;
    const transaction = data?.billing_info;

    // Format date/time
    const createdAt = transaction?.created_at
        ? new Date(transaction.created_at).toLocaleString()
        : 'N/A';

    return (
        <div className={styles.wrapper}>
            <div className={styles.card}>
                <div className={styles.header}>
                    {status === 'success' ? (
                        <span className={styles.iconSuccess}>&#10003;</span>
                    ) : (
                        <span className={styles.iconError}>&#10005;</span>
                    )}
                    <h2>
                        {status === 'success'
                            ? 'Payment Successful'
                            : 'Payment Unsuccessful'}
                    </h2>
                </div>

                {status === 'success' ? (
                    <>
                        <p className={styles.thankYou}>
                            {data.free_trial ? "Thank you for subscribing! Your free trial is now active." : "Thank you for subscribing! Your payment has been received."}

                        </p>

                        <div className={styles.transactionDetails}>
                            <div className={styles.detailRow}>
                                <span>Amount:</span>
                                <span>CAD ${transaction?.amount.toFixed(2) || 'N/A'}</span>
                            </div>
                            <div className={styles.detailRow}>
                                <span>Transaction ID:</span>
                                <span>{transaction?.id || 'N/A'}</span>
                            </div>
                            <div className={styles.detailRow}>
                                <span>Date & Time:</span>
                                <span>{createdAt}</span>
                            </div>
                        </div>
                    </>
                ) : (
                    <p className={styles.errorMessage}>
                        {/* {'An error occurred while processing your payment.'} */}
                        {error}
                    </p>
                )}

                {status === 'success' ? (
                    <Button
                        className={styles.actionButton}
                        onClick={() => (window.location.href = '/')}
                    >
                        Home
                    </Button>
                ) : (
                    <Button
                        className={styles.actionButton}
                        onClick={() => (window.location.href = '/membership-plans')}
                    >
                        Try Again
                    </Button>
                )}
            </div>
        </div>
    );
};

export default PaymentStatus;
